export enum PayoutOrderAutomationStatus {
  InProgress = 'in_progress',
  Rejected = 'rejected',
  Error = 'error',
  Cancelled = 'cancelled',
  Completed = 'completed',
}
